import { baseApi as api } from "../base_api";

const injectedApi = api.injectEndpoints({
  endpoints: (build) => ({
    getStateList: build.query<GetStateListApiResponse, GetStateListApiArg>({
      query: (queryArg) => ({
        url: `/api/account/training/test/${queryArg.countryCode}/stateList`,
      }),
    }),
  }),
  overrideExisting: false,
});

export type GetStateListApiResponse = /** status 200 OK */ CrmStateList;
export interface GetStateListApiArg {
  countryCode: string;
}
export interface CrmState {
  name?: string;
  countryid?: string;
  id?: string;
}
export interface CrmStateList {
  success?: boolean;
  message?: string;
  states?: CrmState[];
}

export const { useGetStateListQuery } = injectedApi;
